import {   put, takeEvery } from 'redux-saga/effects'
import { GenericUpdateActionPayload } from '../../interfaces/action';
import { NavigateApp, GenericUpdate, LoginAdmin, GetAllProviders, UpdateProviderStatus, AppInit } from '../actions';
import { genericApiHandler } from './apiGenerators';



function* genericUpdateHandler(generic: GenericUpdateActionPayload<any>) {
    yield put(GenericUpdate(generic));
}


export function* rootSaga() {
  // [Login]
  yield takeEvery(LoginAdmin, action => genericApiHandler(
    'POST', "api/admin/login", action.payload, 
    {
      successGenericUpdate: {field: "session_data", type: "replace_and_update"},
      success: NavigateApp("/")
    }
  ))

  yield takeEvery(AppInit, function* (action) {
    const token = localStorage.getItem('jwt');
    
    if(token) {
      return genericApiHandler(
        'GET', "api/auth/refresh", token,
        {
          successGenericUpdate: {field: "session_data", type: "replace_and_update"},
          success: NavigateApp("/")
        }
      )
    }
  })

    // [Navigate]
    yield takeEvery(NavigateApp, function* (action) {
      yield put(GenericUpdate({type: 'replace_and_update', field: 'force_redirect', values: action.payload}));
    })

    // [Providers]
    yield takeEvery(GetAllProviders, action => genericApiHandler(
      'GET', "api/provider/getAll", action.payload,
      {
        successGenericUpdate: {field: "all_providers", type: "replace_and_update"}
      }
    ))

    yield takeEvery(UpdateProviderStatus, action => genericApiHandler(
      'POST', "api/provider/updateVerification", action.payload,
      {
        success: GetAllProviders()
      }
    ))
};